<template>
  <Teleport to="body">
    <div
      v-if="open && presentationMode === 'popover'"
      class="ll-calendar__edit-teleport-mask"
      @click.self="emit('mask-close')"
      @contextmenu.prevent
    >
      <div
        ref="boundaryRef"
        class="ll-calendar__boundary-proxy"
        :style="boundaryStyle"
        aria-hidden="true"
      >
        <div
          ref="popoverRef"
          :class="[
            bem.e('edit-popover'),
            `ll-calendar__edit-popover--${placement}`,
            `ll-calendar__teleport-layer`,
          ]"
          :style="style"
          @click.stop
        >
          <div class="ll-calendar__edit-header">
            <div class="ll-calendar__edit-title">{{ title }}</div>
            <ll-button size="small" @click="emit('switch-presentation')">
              切换抽屉
            </ll-button>
          </div>
          <div class="ll-calendar__edit-content">
            <slot name="edit-form" :data="formData">
              <ll-form
                :form-options="{ layout: 'vertical' }"
                :row-options="{ gutter: 12 }"
                :form-data="formData"
                :form-columns="formColumns"
              />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </Teleport>

  <ll-drawer
    v-if="open && presentationMode === 'drawer'"
    :open="open"
    :title="title"
    :width="460"
    :mask-closable="true"
    @confirm="emit('confirm')"
    @cancel="emit('confirm')"
    @close="emit('confirm')"
  >
    <slot name="edit-form" :data="formData">
      <ll-form
        :form-options="{ layout: 'vertical' }"
        :row-options="{ gutter: 12 }"
        :form-data="formData"
        :form-columns="formColumns"
      />
    </slot>
    <template #footer-left>
      <ll-button
        v-if="!isCreatingEvent && canDelete"
        danger
        @click="emit('delete-edit-event')"
      >
        删除
      </ll-button>
    </template>

    <template #footer-right>
      <ll-button style="margin-left: 8px" @click="emit('confirm')">
        保存
      </ll-button>
      <ll-button
        v-if="isCreatingEvent"
        type="primary"
        @click="emit('confirm-and-add')"
      >
        保存后新增
      </ll-button>
    </template>
  </ll-drawer>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { computed, useTemplateRef } from 'vue'

const props = defineProps({
  open: { type: Boolean, required: true },
  presentationMode: { type: String, required: true },
  placement: { type: String, required: true },
  title: { type: String, required: true },
  formData: { type: Object, required: true },
  formColumns: { type: Array, required: true },
  isCreatingEvent: { type: Boolean, required: true },
  currentEditableEvent: { type: Object, required: true },
  style: { type: Object, required: false },
  boundaryStyle: { type: Object, required: false }
})

const emit = defineEmits(["mask-close", "switch-presentation", "confirm", "confirm-and-add", "delete-edit-event"])

const bem = createNamespace('calendar')

const canDelete = computed(() => props.currentEditableEvent.delete !== false)
const popoverRef = useTemplateRef('popoverRef')
const boundaryRef = useTemplateRef('boundaryRef')

defineExpose({
  popoverRef,
  boundaryRef,
})
</script>
